import React from "react"
import type { FC } from "react"

import { UnitName } from "@/models/unit"
import { KBTU_PER_KWH, KBTU_PER_THERM } from "@/utils/constants"

import { Decimal } from "../decimal/decimal"
import type { CombinedVolumePercentProps } from "./combined-volume-percent.types"

export const CombinedVolumePercent: FC<CombinedVolumePercentProps> = ({
  total,
  unit,
  value,
}) => {
  let conversionFactor = 1

  if (unit === UnitName.KilowattHour) {
    conversionFactor = KBTU_PER_KWH
  }

  if (unit === UnitName.Therm) {
    conversionFactor = KBTU_PER_THERM
  }

  const convertedValue: number = value ? value * conversionFactor : 0

  const percent: number = total ? convertedValue / total : 0

  return <Decimal value={percent} format={{ precision: 1, style: "percent" }} />
}
